import {
  AdminPartnerWebService,
  AdminAccountWebService,
  AdminNotificationWebService
} from '@linktivity/gds-neo';
import config from '../config';

const adminPartnerApi = new AdminPartnerWebService.PartnerWebServiceApi(config);
const adminAccountApi = new AdminAccountWebService.AccountWebServiceApi(config);
const adminNotificationApi = new AdminNotificationWebService.NotificationApi(
  config
);

export { adminPartnerApi, adminAccountApi, adminNotificationApi };
